import { InjectionToken } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

export const UI_INPUT_VALIDATION_ERROR_TOKEN = new InjectionToken<ValidationErrors>('UI_INPUT_VALIDATION_ERROR_TOKEN');
